import LinearProgress from "@material-ui/core/LinearProgress";
import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import Divider from "@material-ui/core/Divider";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {ALPHANUM_SPACE} from "../../../../utils/constants/Constants"
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const Contact = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={9}>
                        <TitlePage
                            title={'Mantenimiento \\ Instituciones \\ ' + props.actionScreen + ' \\ ' + props.actionContact +' Contacto'}/>
                    </Grid>
                    <Grid item xs={3}>
                        <div style={{textAlign: 'right'}}>
                            <Button label="Cancelar"
                                    className="p-button-secondary"
                                    onClick={props.handleReturnButton}/>&nbsp;
                            <Button label="Guardar"
                                    onClick={props.pushDataContact}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {props.messagesGrowl}
                            <div className="p-grid">
                                <div className="p-col-3">
                                    <SubtitleLabel header="Tipo" isBold={true}/>
                                    <Dropdown
                                        name="catContactType"
                                        filter={true}
                                        filterBy="DescrTipoMedioComunica"
                                        options={props.contactType}
                                        optionLabel="DescrTipoMedioComunica"
                                        placeholder="Seleccione..."
                                        onChange={props.saveDialogContact}
                                        value={props.dialogContact.catContactType}
                                    />
                                </div>
                                <div className="p-col-3">
                                    <SubtitleLabel header="Descripción" isBold={true}/>
                                    <InputText name="contactDescription"
                                               keyfilter={props.dialogContact.catContactType ?
                                                   props.dialogContact.catContactType.IdTipoMedioComunica === 9 ?
                                                       '' : 'pint' : 'pint'}
                                               maxLength={props.dialogContact.catContactType ?
                                                   props.dialogContact.catContactType.IdTipoMedioComunica === 9 ?
                                                       90 : 20 : 20}
                                               value={props.dialogContact.contactDescription}
                                               onChange={props.saveDialogContact}
                                               placeholder={"Ex: 55-1212-4345"}/>
                                </div>
                                <div className="p-col-6"/>
                                <div className="p-col-3">
                                    <SubtitleLabel header="Contacto Operativo" isBold={true}/>
                                    <InputText name="operativeContact"
                                               keyfilter={ALPHANUM_SPACE}
                                               maxLength={20}
                                               value={props.dialogContact.operativeContact}
                                               onChange={props.saveDialogContact}
                                               placeholder={"Ex: Jonh Smith"}/>
                                </div>
                                <div className="p-col-3">
                                    <SubtitleLabel header="Rol Contacto" isBold={true}/>
                                    <Dropdown
                                        name="catRoleType"
                                        filter={true}
                                        filterBy="DescripcionRolContacto"
                                        options={props.roleType}
                                        optionLabel="DescripcionRolContacto"
                                        placeholder="Seleccione..."
                                        onChange={props.saveDialogContact}
                                        value={props.dialogContact.catRoleType}/>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default Contact;